import { LitElement, css, html, nothing } from 'lit';
import { customElement, state } from 'lit/decorators.js';
import { styles } from '../../public/styles/shared-styles';
import { ensureActiveClub } from "../services/ensureActiveClub";
import { router, resolveRouterPath } from '../router/router';
import { ensureClubBootstrap } from "../services/clubBootstrap";
import {  getActiveSeasonId } from "../services/clubContext";

import './app-login';
import './app-availability';
import './app-events';

import { getApp } from 'firebase/app';
import { getAuth, onAuthStateChanged, type User } from 'firebase/auth';
import {
  collection,
  getFirestore,
  getDocs,
  query,
  orderBy,
  limit,
  doc,
  getDoc,
  where,
  onSnapshot,
  Timestamp,

  type Unsubscribe,
} from 'firebase/firestore';
import { getMessaging, onMessage } from 'firebase/messaging';

import { session } from "../state/session";


type NewsItem = {
  id: string;
  title: string;
  content: string;
  date: Timestamp;
};

type ClubEvent = {
  id: string;
  event?: string;
  title?: string;
  date?: Timestamp | Date | string;
  day?: string;
  time?: string;
  address?: string;
  location?: string;
  type?: string;
};

type TeamOption = {
  id: string;
  name?: string;
};

type HomeFixture = {
  id: string;
  teamId: string;
  opponentName: string;
  venueType: string;
  format?: string | null;
  date: Date;
  meetTime?: Date | null;
  millis: number;
};



type HomeCache = {
  firstName?: string;
  userType?: string;
  playerId?: string | null;
  currentSeasonId?: string | null;
  nextFixtureId?: string | null;
  nextFixtureTeamId?: string | null;
  nextFixtureOpp?: string;
  nextFixtureVenue?: string;
  nextFixtureTime?: string;
  nextFixtureFormat?: string;
  nextdateISO?: string | null;
  fixtureResponse?: 'yes' | 'no' | null;
  cachedAt: number;
};


@customElement('app-home')
export class AppHome extends LitElement {
  @state() isLoggedIn = false;
  @state() user: User | null = null;

  @state() firstName = '';
  @state() userType = 'Player';
  @state() playerId: string | null = null;

  @state() nextFixtureOpp = '';
  @state() nextFixtureVenue = '';
  @state() nextFixtureTime = '';
  @state() nextFixtureFormat = '';
  @state() nextdate: Date | null = null;
  @state() nextFixtureTeam: string[] = [];
  @state() nextFixtureTeamId: string | null = null;
  @state() private allPlayers = new Map<string, string>();


  @state() private currentSeasonId: string | null = null;
  @state() private nextFixtureId: string | null = null;
  @state() private fixtureResponse: 'yes' | 'no' | null = null;

  @state() newsItems: NewsItem[] = [];
  @state() eventsPreview: ClubEvent[] = [];




  private bootstrapped = false;
  private confirmedTeamUnsub: Unsubscribe | null = null;
private fixtureAvailabilityUnsub: Unsubscribe | null = null;
  static styles = [
    styles,
    css`
      :host {
        --card-bg: #ffffff;
        --card-soft: #f8fbf8;
        --ring: rgba(24, 51, 36, 0.08);
        --muted-ink: rgba(24, 51, 36, 0.68);
        --soft-border: rgba(32, 110, 58, 0.12);
        --soft-border-strong: rgba(32, 110, 58, 0.22);

        display: block;
        min-height: 100vh;
        color: var(--text);
        background:
          radial-gradient(900px 600px at 0% -10%, rgba(32, 110, 58, 0.08), transparent 55%),
          radial-gradient(900px 600px at 100% 0%, rgba(32, 110, 58, 0.06), transparent 50%),
          linear-gradient(180deg, #f5f8f5, #ebf2ec);
      }

      .page {
        max-width: 1280px;
        margin: 0 auto;
        padding: 12px 16px 64px;
      }

      .first-stat {
        padding-top: 115px;
      }

      .stack {
        display: flex;
        flex-direction: column;
        gap: 18px;
      }

      .hero {
        display: grid;
        grid-template-columns: minmax(0, 1.2fr) minmax(280px, 0.8fr);
        gap: 18px;
        align-items: stretch;
      }

      .heroCard,
      .panel,
      .fixtureCard,
      .eventCard,
      .newsCard,
      .actionCard {
        border-radius: 22px;
        border: 1px solid var(--soft-border);
        background: linear-gradient(180deg, var(--card-bg), var(--card-soft));
        box-shadow: 0 10px 28px var(--ring);
      }

      .heroCard {
        padding: 24px;
      }

      .brandline {
        display: flex;
        align-items: center;
        gap: 14px;
      }

      .logo {
        width: 78px;
        height: 78px;
        border-radius: 14px;
        overflow: hidden;
        box-shadow: 0 4px 16px rgba(24, 51, 36, 0.12);
        background: white;
        flex: 0 0 auto;
      }

      .logo > img {
        width: 100%;
        height: 100%;
        object-fit: contain;
        display: block;
      }

      .title {
        font-size: 2rem;
        line-height: 1;
        font-weight: 800;
        letter-spacing: -0.04em;
        color: var(--text);
      }

      .tagline {
        color: var(--muted-ink);
        margin-top: 6px;
        font-size: 1rem;
        line-height: 1.5;
      }

      .heroMeta {
        display: flex;
        gap: 10px;
        flex-wrap: wrap;
        margin-top: 18px;
      }

      .pill {
        display: inline-flex;
        align-items: center;
        gap: 6px;
        padding: 7px 10px;
        border-radius: 999px;
        border: 1px solid var(--soft-border);
        background: rgba(255, 255, 255, 0.88);
        color: var(--text);
        font-size: 12px;
        font-weight: 700;
      }

      .noticeCard {
        padding: 18px;
        background: linear-gradient(135deg, rgba(32, 110, 58, 0.92), rgba(47, 138, 75, 0.92));
        color: white;
        border-radius: 22px;
        box-shadow: 0 12px 28px rgba(32, 110, 58, 0.18);
      }

      .noticeTitle {
        font-size: 0.85rem;
        text-transform: uppercase;
        letter-spacing: 0.08em;
        opacity: 0.8;
        font-weight: 800;
      }

      .noticeText {
        margin-top: 8px;
        font-size: 1rem;
        line-height: 1.5;
        font-weight: 700;
      }

      .noticeSubText {
        margin-top: 6px;
        font-size: 0.86rem;
        line-height: 1.45;
        opacity: 0.88;
      }

      .noticeActions {
        display: flex;
        gap: 10px;
        align-items: center;
        flex-wrap: wrap;
        margin-top: 14px;
      }

      .noticeButton {
        border: none;
        border-radius: 14px;
        padding: 11px 14px;
        background: #ffffff;
        color: var(--primary);
        font-weight: 900;
        cursor: pointer;
        box-shadow: 0 8px 18px rgba(0, 0, 0, 0.12);
      }

      .noticeButton[disabled] {
        opacity: 0.68;
        cursor: not-allowed;
      }

      .noticeCard.paid {
        background: linear-gradient(135deg, rgba(32, 110, 58, 0.92), rgba(47, 138, 75, 0.92));
      }

      .noticeCard.unpaid {
        background: linear-gradient(135deg, rgba(145, 84, 15, 0.96), rgba(194, 121, 30, 0.94));
      }

      .noticeCard.error {
        background: linear-gradient(135deg, rgba(150, 38, 38, 0.96), rgba(194, 65, 65, 0.92));
      }

      .summaryGrid {
        display: grid;
        grid-template-columns: repeat(4, minmax(0, 1fr));
        gap: 12px;
      }

      .summaryCard {
        padding: 16px;
        border-radius: 18px;
        border: 1px solid var(--soft-border);
        background: rgba(255, 255, 255, 0.9);
      }

      .summaryLabel {
        font-size: 12px;
        color: var(--muted-ink);
      }

      .summaryValue {
        margin-top: 8px;
        font-size: 1.6rem;
        font-weight: 800;
        letter-spacing: -0.03em;
        color: var(--text);
      }

      .summarySub {
        margin-top: 6px;
        font-size: 12px;
        color: var(--muted-ink);
      }

      .quickGrid {
        display: grid;
        grid-template-columns: repeat(4, minmax(0, 1fr));
        gap: 12px;
      }

      .actionCard {
        min-height: 112px;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        padding: 18px 16px;
        cursor: pointer;
        transition: transform 120ms ease, box-shadow 120ms ease, border-color 120ms ease;
      }

      .actionCard:hover {
        transform: translateY(-2px);
        border-color: var(--soft-border-strong);
        box-shadow: 0 14px 30px rgba(24, 51, 36, 0.09);
      }

      .actionIcon {
        font-size: 1.45rem;
        margin-bottom: 8px;
      }

      .actionTitle {
        font-size: 1rem;
        font-weight: 800;
        color: var(--text);
      }

      .actionSub {
        margin-top: 4px;
        font-size: 0.88rem;
        color: var(--muted-ink);
        line-height: 1.45;
      }

      .mainGrid {
        display: grid;
        grid-template-columns: minmax(0, 1.15fr) minmax(320px, 0.85fr);
        gap: 18px;
        align-items: start;
      }

      .panelHeader {
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 12px;
        padding: 16px 18px 12px;
        border-bottom: 1px solid rgba(32, 110, 58, 0.08);
      }

      .panelTitle {
        font-size: 1.05rem;
        font-weight: 800;
        color: var(--text);
      }

      .panelSub {
        font-size: 0.84rem;
        color: var(--muted-ink);
        margin-top: 4px;
      }

      .panelBody {
        padding: 16px 18px 18px;
      }

      .fixtureCard {
        padding: 20px 20px 20px 26px;
        position: relative;
        overflow: hidden;
      }

      .fixtureCard::before {
        content: "";
        position: absolute;
        left: 0;
        top: 0;
        bottom: 0;
        width: 7px;
        background: var(--primary);
      }

      .fixtureTitle {
        font-size: 1.45rem;
        font-weight: 800;
        letter-spacing: -0.03em;
        color: var(--text);
      }

      .fixtureBadges {
        margin-top: 10px;
        display: flex;
        flex-wrap: wrap;
        gap: 8px;
      }

      .fixtureBadge {
        padding: 6px 10px;
        border-radius: 999px;
        background: rgba(32, 110, 58, 0.08);
        border: 1px solid rgba(32, 110, 58, 0.12);
        font-size: 12px;
        color: var(--primary);
        font-weight: 800;
      }

      .fixtureMeta {
        display: grid;
        grid-template-columns: repeat(2, minmax(0, 1fr));
        gap: 10px;
        margin-top: 14px;
      }

      .metaTile {
        padding: 12px 14px;
        border-radius: 16px;
        background: rgba(32, 110, 58, 0.05);
        border: 1px solid rgba(32, 110, 58, 0.08);
      }

      .metaLabel {
        font-size: 11px;
        text-transform: uppercase;
        letter-spacing: 0.06em;
        color: var(--muted-ink);
        font-weight: 800;
      }

      .metaValue {
        margin-top: 6px;
        font-size: 0.95rem;
        font-weight: 800;
        color: var(--text);
      }

      .rsvp {
        display: flex;
        gap: 10px;
        margin-top: 16px;
        flex-wrap: wrap;
      }

      .btn {
        flex: 1;
        min-width: 140px;
        border: 1px solid var(--primary);
        background: white;
        color: var(--primary);
        border-radius: 14px;
        padding: 12px 14px;
        font-weight: 800;
        cursor: pointer;
        box-shadow: 0 4px 14px rgba(24, 51, 36, 0.05);
      }

      .btn-yes.active {
        background: var(--primary);
        color: var(--primary-contrast);
      }

      .btn-no {
        border-color: var(--error);
        color: var(--error);
      }

      .btn-no.active {
        background: var(--error);
        color: white;
        border-color: var(--error);
      }

      .btn[disabled] {
        opacity: 0.6;
        cursor: not-allowed;
      }

      .hint {
        margin-top: 10px;
        color: var(--muted-ink);
        font-size: 0.9rem;
        line-height: 1.45;
      }

      .teamList {
        margin-top: 14px;
        display: flex;
        flex-wrap: wrap;
        gap: 8px;
      }

      .teamPill {
        padding: 7px 10px;
        border-radius: 999px;
        background: rgba(32, 110, 58, 0.08);
        border: 1px solid rgba(32, 110, 58, 0.12);
        font-size: 12px;
        font-weight: 700;
      }

      .cardList {
        display: flex;
        flex-direction: column;
        gap: 12px;
      }

      .eventCard,
      .newsCard {
        padding: 16px;
      }

      .eventTitle,
      .newsTitle {
        font-size: 1rem;
        font-weight: 800;
        color: var(--text);
      }

      .eventGrid {
        display: grid;
        gap: 6px;
        margin-top: 10px;
      }

      .eventRow {
        font-size: 0.9rem;
        color: var(--text);
      }

      .newsBody {
        margin-top: 8px;
        color: var(--muted-ink);
        line-height: 1.5;
        font-size: 0.92rem;
      }

      .newsDate {
        margin-top: 6px;
        color: var(--muted-ink);
        font-size: 0.88rem;
      }

      .selectionStatusCard {
  border-radius: 22px;
  border: 1px solid var(--soft-border);
  background: linear-gradient(180deg, #ffffff, #f8fbf8);
  box-shadow: 0 10px 28px var(--ring);
  overflow: hidden;
}

.selectionStatusCard.needsResponse {
  border-color: rgba(245, 158, 11, 0.32);
  background: linear-gradient(180deg, #fffdf6, #fff8e7);
}

.selectionStatusCard.selected {
  border-color: rgba(32, 110, 58, 0.3);
  background: linear-gradient(180deg, #f3fff7, #ffffff);
}

.selectionStatusCard.notSelected {
  border-color: rgba(59, 130, 246, 0.24);
  background: linear-gradient(180deg, #f5f9ff, #ffffff);
}

.selectionStatusCard.unavailable {
  border-color: rgba(220, 38, 38, 0.22);
  background: linear-gradient(180deg, #fff7f7, #ffffff);
}

.selectionStatusInner {
  padding: 18px;
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  gap: 16px;
  align-items: center;
}

.selectionKicker {
  font-size: 0.78rem;
  font-weight: 800;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  color: var(--muted-ink);
}

.selectionTitle {
  margin-top: 6px;
  font-size: 1.35rem;
  font-weight: 900;
  letter-spacing: -0.04em;
  color: var(--text);
}

.selectionText {
  margin-top: 6px;
  color: var(--muted-ink);
  line-height: 1.45;
  font-size: 0.92rem;
}

.selectionMetaRow {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 12px;
}

.selectionMetaPill {
  display: inline-flex;
  align-items: center;
  padding: 7px 10px;
  border-radius: 999px;
  border: 1px solid rgba(32, 110, 58, 0.12);
  background: rgba(255, 255, 255, 0.8);
  color: var(--text);
  font-size: 12px;
  font-weight: 800;
}

.selectionAction {
  min-width: 170px;
}

.selectionBtn {
  width: 100%;
  border: none;
  border-radius: 14px;
  padding: 12px 14px;
  background: var(--primary);
  color: var(--primary-contrast);
  font-weight: 900;
  cursor: pointer;
  box-shadow: 0 8px 18px rgba(32, 110, 58, 0.16);
}

.selectionBtn.secondary {
  background: white;
  color: var(--primary);
  border: 1px solid rgba(32, 110, 58, 0.18);
  box-shadow: none;
}

@media (max-width: 720px) {
  .selectionStatusInner {
    grid-template-columns: 1fr;
  }

  .selectionAction {
    min-width: 0;
  }
}

      .empty {
        padding: 16px;
        border-radius: 16px;
        border: 1px dashed rgba(32, 110, 58, 0.16);
        background: rgba(255, 255, 255, 0.72);
        color: var(--muted-ink);
      }

      @media (max-width: 1100px) {
        .hero,
        .mainGrid {
          grid-template-columns: 1fr;
        }

        .summaryGrid,
        .quickGrid {
          grid-template-columns: repeat(2, minmax(0, 1fr));
        }
      }

      @media (max-width: 720px) {
        .page {
          padding: 10px 12px 40px;
        }

        .first-stat {
          padding-top: 100px;
        }

        .heroCard,
        .noticeCard,
        .fixtureCard,
        .panel,
        .actionCard {
          border-radius: 18px;
        }

        .heroCard {
          padding: 18px;
        }

        .title {
          font-size: 1.55rem;
        }

        .logo {
          width: 64px;
          height: 64px;
        }

        .summaryGrid,
        .quickGrid,
        .fixtureMeta {
          grid-template-columns: 1fr;
        }

        .rsvp {
          flex-direction: column;
        }

        .btn {
          width: 100%;
          min-width: 0;
        }
      }
    `
  ];

  connectedCallback() {

super.connectedCallback();


    session.bootstrap();

    this.setupOnMessageHandler();
    this.initAuth();
  }

  disconnectedCallback() {

super.disconnectedCallback();

this.fixtureAvailabilityUnsub?.();
this.fixtureAvailabilityUnsub = null;
    this.confirmedTeamUnsub?.();
    this.confirmedTeamUnsub = null;
  }


  private initAuth() {
    const auth = getAuth();

    onAuthStateChanged(auth, async (user) => {
      if (user) {
        session.setUser(user);
        this.user = user;
        this.isLoggedIn = true;

const clubId = await ensureActiveClub();
if (!clubId) {
  router.navigate("/join");
  return;
}

this.loadHomeCache(clubId, user.uid);

await this.fetchUserProfile(clubId, user.uid);
await this.subscribeNextFixtureAcrossTeams(clubId);

this.saveHomeCache(clubId, user.uid);
        if (!this.bootstrapped) {
          this.bootstrapped = true;
          try {
            await ensureClubBootstrap(clubId);
          } catch (e) {
            console.warn("ensureClubBootstrap failed", e);
          }
        }

    await this.fetchUserProfile(clubId, user.uid);

await Promise.allSettled([
  this.loadNewsBatch(clubId),
  this.loadEventsPreview(clubId),
]);

await this.subscribeNextFixtureAcrossTeams(clubId);

      } else {
        session.setUser(null);
        this.user = null;
        this.isLoggedIn = false;
        this.firstName = '';
        this.userType = 'Player';
        this.playerId = null;

        if (window.location.pathname !== resolveRouterPath('home')) {
          router.navigate(resolveRouterPath('login'));
        }
      }
    });
  }

  private cacheKey(clubId: string, uid: string) {
  return `appletoncc_home_cache_${clubId}_${uid}`;
}

private loadHomeCache(clubId: string, uid: string) {
  try {
    const raw = localStorage.getItem(this.cacheKey(clubId, uid));
    if (!raw) return;

    const cache = JSON.parse(raw) as HomeCache;

    this.firstName = cache.firstName || this.firstName;
    this.userType = cache.userType || this.userType;
    this.playerId = cache.playerId ?? this.playerId;
    this.currentSeasonId = cache.currentSeasonId ?? this.currentSeasonId;
    this.nextFixtureId = cache.nextFixtureId ?? this.nextFixtureId;
    this.nextFixtureTeamId = cache.nextFixtureTeamId ?? this.nextFixtureTeamId;
    this.nextFixtureOpp = cache.nextFixtureOpp || this.nextFixtureOpp;
    this.nextFixtureVenue = cache.nextFixtureVenue || this.nextFixtureVenue;
    this.nextFixtureTime = cache.nextFixtureTime || this.nextFixtureTime;
    this.nextFixtureFormat = cache.nextFixtureFormat || this.nextFixtureFormat;
    this.fixtureResponse = cache.fixtureResponse ?? this.fixtureResponse;
    this.nextdate = cache.nextdateISO ? new Date(cache.nextdateISO) : this.nextdate;
  } catch {
    // ignore bad cache
  }
}

private saveHomeCache(clubId: string, uid: string) {
  const cache: HomeCache = {
    firstName: this.firstName,
    userType: this.userType,
    playerId: this.playerId,
    currentSeasonId: this.currentSeasonId,
    nextFixtureId: this.nextFixtureId,
    nextFixtureTeamId: this.nextFixtureTeamId,
    nextFixtureOpp: this.nextFixtureOpp,
    nextFixtureVenue: this.nextFixtureVenue,
    nextFixtureTime: this.nextFixtureTime,
    nextFixtureFormat: this.nextFixtureFormat,
    nextdateISO: this.nextdate ? this.nextdate.toISOString() : null,
    fixtureResponse: this.fixtureResponse,
    cachedAt: Date.now(),
  };

  localStorage.setItem(this.cacheKey(clubId, uid), JSON.stringify(cache));
}


  private async fetchUserProfile(clubId: string, uid: string) {
    const db = getFirestore();

    try {
      const userSnap = await getDoc(doc(db, `Users/${uid}`));
      const userData = userSnap.exists() ? (userSnap.data() as any) : {};

      let memberData: any = {};
      const memberSnap = await getDoc(doc(db, `Clubs/${clubId}/Members/${uid}`));

      if (memberSnap.exists()) {
        memberData = memberSnap.data();
      }

      let linkedPlayerId =
        memberData.playerId ||
        memberData.player_id ||
        userData.playerId ||
        userData.player_id ||
        uid;

      let playerData: any = {};

      const directPlayerSnap = await getDoc(doc(db, `Clubs/${clubId}/Players/${linkedPlayerId}`));
      if (directPlayerSnap.exists()) {
        playerData = directPlayerSnap.data();
        linkedPlayerId = directPlayerSnap.id;
      } else {
        const byLegacyUid = await getDocs(
          query(collection(db, `Clubs/${clubId}/Players`), where('legacy.uid', '==', uid), limit(1))
        );

        if (!byLegacyUid.empty) {
          linkedPlayerId = byLegacyUid.docs[0].id;
          playerData = byLegacyUid.docs[0].data();
        }
      }

      this.playerId = String(linkedPlayerId);

      if (Array.isArray(memberData.roles) && memberData.roles.length) {
        this.userType = String(memberData.roles[0]);
      } else {
        this.userType = 'Player';
      }

      const profile = playerData.profile ?? {};

      const displayName =
        String(playerData.displayName ?? '').trim() ||
        String(playerData.name ?? '').trim() ||
        `${String(profile.firstName ?? '').trim()} ${String(profile.lastName ?? '').trim()}`.trim() ||
        `${String(playerData.firstName ?? '').trim()} ${String(playerData.lastName ?? '').trim()}`.trim() ||
        String(memberData.displayName ?? '').trim() ||
        String(userData.displayName ?? '').trim() ||
        String(this.user?.displayName ?? '').trim() ||
        String(this.user?.email ?? '').split('@')[0] ||
        'Player';

      this.firstName = displayName.split(' ')[0] || 'Player';

      console.log('HOME PROFILE DEBUG', {
        uid,
        clubId,
        linkedPlayerId,
        firstName: this.firstName,
        userType: this.userType,
      });
    } catch (e) {
      console.error('fetchUserProfile error', e);
      this.firstName = 'Player';
      this.userType = 'Player';
      this.playerId = uid;
    }
  }



  private async fetchAllPlayers(clubId: string) {
    const db = getFirestore();
    this.allPlayers.clear();

    try {
      const snap = await getDocs(collection(db, `Clubs/${clubId}/Players`));

      snap.docs.forEach((d) => {
        const data = d.data() as any;
        const profile = data.profile ?? {};

        const label =
          String(data.displayName ?? '').trim() ||
          String(data.name ?? '').trim() ||
          `${String(profile.firstName ?? '').trim()} ${String(profile.lastName ?? '').trim()}`.trim() ||
          `${String(data.firstName ?? '').trim()} ${String(data.lastName ?? '').trim()}`.trim() ||
          d.id;

        this.allPlayers.set(d.id, label);
      });
    } catch (e) {
      console.error('fetchAllPlayers error', e);
    }
  }

private async loadNewsBatch(clubId: string) {
  try {
    const db = getFirestore();

    const newsQuery = query(
      collection(db, `Clubs/${clubId}/News`),
      orderBy('date', 'desc'),
      limit(4)
    );

    const newsSnapshot = await getDocs(newsQuery);

    this.newsItems = newsSnapshot.docs.map((docSnap) => {
      const data = docSnap.data() as any;
      return {
        id: docSnap.id,
        title: data.title || 'Club update',
        content: data.content || '',
        date: data.date,
      } as NewsItem;
    });
  } catch (e) {
    console.warn('Could not load club news', e);
    this.newsItems = [];
  }
}

private async loadEventsPreview(clubId: string) {
  try {
    const db = getFirestore();

    const qy = query(
      collection(db, `Clubs/${clubId}/Events`),
      orderBy('date', 'asc'),
      limit(4)
    );

    const snap = await getDocs(qy);

    const now = Date.now();

    this.eventsPreview = snap.docs
      .map((d) => ({ id: d.id, ...(d.data() as any) }))
      .filter((e: any) => {
        const d = this.coerceToDate(e.date);
        return d ? d.getTime() >= now : true;
      })
      .slice(0, 2);

    await this.loadMyEventResponses(clubId);
  } catch (e) {
    console.warn('Could not load club events', e);
    this.eventsPreview = [];
  }
}

private async loadMyEventResponses(clubId: string) {
  if (!this.user || this.eventsPreview.length === 0) return;

  try {
    const db = getFirestore();

    const pairs = await Promise.all(
      this.eventsPreview.map(async (e) => {
        const r = await getDoc(
          doc(db, `Clubs/${clubId}/Events/${e.id}/Attendance/${this.user!.uid}`)
        );

        return [e.id, r.exists() ? ((r.data() as any).status as 'yes' | 'no') : null] as const;
      })
    );

    const map: Record<string, 'yes' | 'no' | null> = {};
    pairs.forEach(([id, status]) => {
      map[id] = status;
    });


  } catch (e) {
    console.warn('Could not load event responses', e);

  }
}


  private async getSeasonIdForHome(clubId: string): Promise<string | null> {
    if (this.user) {
      const userSnap = await getDoc(doc(getFirestore(), `Users/${this.user.uid}`));
      const activeSeasonId = userSnap.exists() ? (userSnap.data() as any).activeSeasonId : null;
      if (activeSeasonId) return String(activeSeasonId);
    }

    const contextSeason = getActiveSeasonId();
    if (contextSeason) return String(contextSeason);

    const snap = await getDocs(collection(getFirestore(), `Clubs/${clubId}/Seasons`));
    const ids = snap.docs.map((d) => d.id).sort((a, b) => b.localeCompare(a));
    return ids[0] ?? '2026';
  }

  private normaliseTeamId(id: string): string {
    const clean = String(id || '').trim().toLowerCase();
    if (clean === 'wednesday') return 'midweek';
    return clean;
  }

  private async getTeamIdsForHome(clubId: string): Promise<string[]> {
    const db = getFirestore();

    try {
      const configSnap = await getDoc(doc(db, `Clubs/${clubId}/Settings/ClubConfig`));
      const teamOptions = (configSnap.exists() ? (configSnap.data() as any)?.teamOptions : []) ?? [];

      const ids = Array.isArray(teamOptions)
        ? teamOptions
            .map((t: TeamOption) => this.normaliseTeamId(String(t.id || '')))
            .filter(Boolean)
        : [];

      return Array.from(new Set([...ids, 'sunday', 'midweek']));
    } catch {
      return ['sunday', 'midweek'];
    }
  }

  private toDate(value: any): Date | null {
    if (!value) return null;
    if (value instanceof Date) return value;
    if (value?.toDate) return value.toDate();

    const d = new Date(value);
    return Number.isNaN(d.getTime()) ? null : d;
  }

  private async subscribeNextFixtureAcrossTeams(clubId: string) {
    if (!this.user) return;

    const db = getFirestore();
    const seasonId = await this.getSeasonIdForHome(clubId);

    if (!seasonId) {
      this.clearNextFixture();
      return;
    }

    const teamIds = await this.getTeamIdsForHome(clubId);
    const now = Date.now();
    const allFixtures: HomeFixture[] = [];

    console.log('HOME FIXTURE DEBUG - START', { clubId, seasonId, teamIds });

    await Promise.all(
      teamIds.map(async (teamId) => {
        try {
          const fixturesRef = collection(
            db,
            `Clubs/${clubId}/Seasons/${seasonId}/Teams/${teamId}/Fixtures`
          );

         const snap = await getDocs(
  query(
    fixturesRef,
    where('date', '>=', Timestamp.fromDate(new Date(new Date().setHours(0, 0, 0, 0)))),
    orderBy('date', 'asc'),
    limit(3)
  )
);

          console.log(`HOME FIXTURE DEBUG - ${teamId}`, {
            path: `Clubs/${clubId}/Seasons/${seasonId}/Teams/${teamId}/Fixtures`,
            count: snap.size,
          });

          snap.docs.forEach((fxDoc) => {
            const fx = fxDoc.data() as any;
            const date = this.toDate(fx.date ?? fx.dateISO ?? fx.fixtureDate);
            if (!date) return;

            const millis = date.getTime();
            if (millis < now) return;

            allFixtures.push({
              id: fxDoc.id,
              teamId,
              opponentName:
                String(fx.opponentName ?? '').trim() ||
                String(fx.opponent ?? '').trim() ||
                String(fx.opposition ?? '').trim() ||
                String(fx.title ?? '').trim() ||
                'Opponent TBC',
              venueType:
                String(fx.venueType ?? '').trim() ||
                String(fx.venue ?? '').trim() ||
                String(fx.location ?? '').trim() ||
                'TBC',
              format: fx.format ?? null,
              date,
              meetTime: this.toDate(fx.meetTime),
              millis,
            });
          });
        } catch (e) {
          console.warn(`Failed reading fixtures for team ${teamId}`, e);
        }
      })
    );

    allFixtures.sort((a, b) => a.millis - b.millis);

    console.log('HOME FIXTURE DEBUG - FOUND', allFixtures);

    const nextFixture = allFixtures[0];

    if (!nextFixture) {
      this.currentSeasonId = seasonId;
      this.clearNextFixture();
      return;
    }

    this.currentSeasonId = seasonId;
    this.nextFixtureId = nextFixture.id;
    this.nextFixtureTeamId = nextFixture.teamId;
    this.nextFixtureOpp = nextFixture.opponentName;
    this.nextFixtureVenue = nextFixture.venueType;
    this.nextFixtureFormat = String(nextFixture.format ?? '').trim();
    this.nextdate = nextFixture.date;
    this.nextFixtureTime = nextFixture.date.toLocaleTimeString('en-GB', {
      hour: '2-digit',
      minute: '2-digit',
    });

    this.confirmedTeamUnsub?.();

    const confirmedRef = doc(
      db,
      `Clubs/${clubId}/Seasons/${seasonId}/Teams/${nextFixture.teamId}/Fixtures/${nextFixture.id}/Team/Confirmed`
    );

 this.confirmedTeamUnsub = onSnapshot(confirmedRef, async (snap) => {
  const d = snap.data() as any;

  const rawPlayerIds: unknown[] = Array.isArray(d?.playerIds)
    ? d.playerIds
    : [];

  const playerIds: string[] = rawPlayerIds
    .map((id): string => String(id ?? "").trim())
    .filter((id): id is string => id.length > 0);

  this.nextFixtureTeam = [...new Set<string>(playerIds)];

  if (this.nextFixtureTeam.length && this.allPlayers.size === 0) {
    await this.fetchAllPlayers(clubId);
  }

  if (this.user) {
    this.saveHomeCache(clubId, this.user.uid);
  }
});
    await this.loadMyFixtureAvailability(clubId, seasonId, nextFixture.teamId, nextFixture.id);
  }

  private clearNextFixture() {
    this.nextFixtureId = null;
    this.nextFixtureTeamId = null;
    this.nextFixtureOpp = '';
    this.nextFixtureVenue = '';
    this.nextFixtureTime = '';
    this.nextFixtureFormat = '';
    this.nextdate = null;
    this.nextFixtureTeam = [];
    this.fixtureResponse = null;
  }

 private async loadMyFixtureAvailability(
  clubId: string,
  seasonId: string,
  teamId: string,
  fixtureId: string
) {
  if (!this.user) return;

  this.fixtureAvailabilityUnsub?.();

  const db = getFirestore();
  const availabilityId = this.playerId || this.user.uid;

  const ref = doc(
    db,
    `Clubs/${clubId}/Seasons/${seasonId}/Teams/${teamId}/Fixtures/${fixtureId}/Availability/${availabilityId}`
  );

  this.fixtureAvailabilityUnsub = onSnapshot(ref, (snap) => {
    const data = snap.exists() ? (snap.data() as any) : null;

    if (!data) {
      this.fixtureResponse = null;
    } else if (data.availability === true || data.status === "yes") {
      this.fixtureResponse = "yes";
    } else if (data.availability === false || data.status === "no") {
      this.fixtureResponse = "no";
    } else {
      this.fixtureResponse = null;
    }

    this.saveHomeCache(clubId, this.user!.uid);
  });
}




















  private setupOnMessageHandler() {
    navigator.serviceWorker.ready.then(() => {
      const messaging = getMessaging(getApp());
      onMessage(messaging, (payload) => {
        const n = (payload as any).notification;
        if (!n) return;
        new Notification(n.title || 'Notification', {
          body: n.body || '',
          icon: '/assets/icons/icon_192.png',
        });
      });
    });
  }





  private coerceToDate(v: any): Date | null {
    if (!v) return null;
    if (v instanceof Date) return v;
    if ((v as Timestamp)?.toDate) return (v as Timestamp).toDate();
    const d = new Date(v);
    return Number.isNaN(d.getTime()) ? null : d;
  }

private isCurrentUserSelectedForNextFixture(): boolean {
  const selectedIds = new Set(
    this.nextFixtureTeam
      .map((id) => String(id ?? "").trim())
      .filter(Boolean)
  );

  const possibleIds = [
    this.playerId,
    this.user?.uid,
  ]
    .map((id) => String(id ?? "").trim())
    .filter(Boolean);

  return possibleIds.some((id) => selectedIds.has(id));
}

private nextFixtureDateLabel(): string {
  if (!this.nextdate) return "Date TBC";

  return this.nextdate.toLocaleDateString("en-GB", {
    weekday: "short",
    day: "2-digit",
    month: "short",
  });
}

private goToNextFixtureAvailability() {
  const base = resolveRouterPath("availability");

  if (!this.currentSeasonId || !this.nextFixtureTeamId || !this.nextFixtureId) {
    router.navigate(base);
    return;
  }

  const params = new URLSearchParams({
    seasonId: this.currentSeasonId,
    teamId: this.nextFixtureTeamId,
    fixtureId: this.nextFixtureId,
  });

  router.navigate(`${base}?${params.toString()}`);
}

private renderNextSelectionStatus() {
  if (!this.nextFixtureId) {
    return html`
      <section class="selectionStatusCard">
        <div class="selectionStatusInner">
          <div>
            <div class="selectionKicker">Selection status</div>
            <div class="selectionTitle">No upcoming fixture found</div>
            <div class="selectionText">
              Once the next fixture is available, your availability and selection status will appear here.
            </div>
          </div>

          <div class="selectionAction">
            <button class="selectionBtn secondary" @click=${() => router.navigate(resolveRouterPath("fixtures"))}>
              View fixtures
            </button>
          </div>
        </div>
      </section>
    `;
  }

  const hasResponded = this.fixtureResponse === "yes" || this.fixtureResponse === "no";
  const selected = this.fixtureResponse === "yes" && this.isCurrentUserSelectedForNextFixture();

  let cardClass = "needsResponse";
  let title = "Availability needed";
  let text = `Please let the club know whether you are available for ${this.nextFixtureOpp || "the next fixture"}.`;
  let responseLabel = "No response yet";
  let selectionLabel = "Selection pending";
  let buttonLabel = "Set availability";

  if (this.fixtureResponse === "no") {
    cardClass = "unavailable";
    title = "You are not available";
    text = `You have marked yourself as unavailable for ${this.nextFixtureOpp || "the next fixture"}.`;
    responseLabel = "Response: No";
    selectionLabel = "Not selected";
    buttonLabel = "Change availability";
  } else if (selected) {
    cardClass = "selected";
    title = "You are selected";
    text = `You are currently in the confirmed team for ${this.nextFixtureOpp || "the next fixture"}.`;
    responseLabel = "Response: Yes";
    selectionLabel = "Selected";
    buttonLabel = "View availability";
  } else if (hasResponded) {
    cardClass = "notSelected";
    title = "You are not currently selected";
    text = `You have marked yourself as available, but you are not currently in the confirmed team.`;
    responseLabel = "Response: Yes";
    selectionLabel = "Not selected";
    buttonLabel = "View availability";
  }

  return html`
    <section class="selectionStatusCard ${cardClass}">
      <div class="selectionStatusInner">
        <div>
          <div class="selectionKicker">Next fixture selection</div>
          <div class="selectionTitle">${title}</div>
          <div class="selectionText">${text}</div>

          <div class="selectionMetaRow">
            <span class="selectionMetaPill">${this.nextFixtureOpp || "Opponent TBC"}</span>
            <span class="selectionMetaPill">${this.nextFixtureDateLabel()}</span>
            ${this.nextFixtureTime ? html`<span class="selectionMetaPill">${this.nextFixtureTime}</span>` : nothing}
            <span class="selectionMetaPill">${responseLabel}</span>
            <span class="selectionMetaPill">${selectionLabel}</span>
          </div>
        </div>

        <div class="selectionAction">
          <button class="selectionBtn" @click=${() => this.goToNextFixtureAvailability()}>
            ${buttonLabel}
          </button>
        </div>
      </div>
    </section>
  `;
}



  private renderSummaryCards() {
    return html`
      <div class="summaryGrid">
        <div class="summaryCard">
          <div class="summaryLabel">Welcome</div>
          <div class="summaryValue">${this.firstName || 'Player'}</div>
          <div class="summarySub">${this.userType || 'Player'}</div>
        </div>

        <div class="summaryCard">
          <div class="summaryLabel">Next fixture</div>
          <div class="summaryValue">${this.nextFixtureOpp || 'TBC'}</div>
          <div class="summarySub">
            ${this.nextdate ? this.nextdate.toLocaleDateString('en-GB') : 'No upcoming fixture'}
          </div>
        </div>

        <div class="summaryCard">
          <div class="summaryLabel">Events</div>
          <div class="summaryValue">${this.eventsPreview.length}</div>
          <div class="summarySub">Upcoming club events currently shown</div>
        </div>

        <div class="summaryCard">
          <div class="summaryLabel">News</div>
          <div class="summaryValue">${this.newsItems.length}</div>
          <div class="summarySub">Latest updates from the club</div>
        </div>
      </div>
    `;
  }

  private renderQuickActions() {
    const actions = [
      {
        icon: '📅',
        title: 'Fixtures',
        sub: 'View upcoming games and fixture details',
        go: () => router.navigate(resolveRouterPath('fixtures')),
      },
      {
        icon: '✅',
        title: 'Availability',
        sub: 'Update your availability and selection status',
        go: () => router.navigate(resolveRouterPath('availability')),
      },
      {
        icon: '📈',
        title: 'Leaderboard',
        sub: 'See current rankings and performance',
        go: () => router.navigate(resolveRouterPath('leaderboard')),
      },
      {
        icon: '🧑',
        title: 'Profile',
        sub: 'View your player profile and details',
        go: () => router.navigate(resolveRouterPath('profile')),
      },
    ];

    return html`
      <div class="quickGrid">
        ${actions.map(
          (a) => html`
            <div class="actionCard" @click=${a.go}>
              <div class="actionIcon">${a.icon}</div>
              <div class="actionTitle">${a.title}</div>
              <div class="actionSub">${a.sub}</div>
            </div>
          `
        )}
      </div>
    `;
  }







  render() {
    return html`
      <app-header pageTitle="Welcome 🏆"></app-header>

      <div class="page first-stat">
        <div class="stack">
          <section class="hero">
            <div class="heroCard">
              <div class="brandline">
                <div class="logo">
                  <img
                    src="/assets/images/appletonlogo.png"
                    alt="Appleton CC logo"
                    loading="lazy"
                    decoding="async"
                  />
                </div>

                <div>
                  <div class="title">Appleton Cricket Hub</div>
                  <div class="tagline">Your club. Your cricket. All in one place.</div>
                </div>
              </div>

              <div class="heroMeta">
                <span class="pill">Welcome ${this.firstName || 'Player'}</span>
                <span class="pill">${this.userType || 'Player'}</span>
                ${this.currentSeasonId ? html`<span class="pill">Season ${this.currentSeasonId}</span>` : nothing}
              </div>
            </div>
          </section>
${this.renderNextSelectionStatus()}
        ${this.renderSummaryCards()}

${this.renderQuickActions()}

          <div class="mainGrid">

            <div class="stack">

            </div>
          </div>
        </div>
      </div>
    `;
  }
}